module.exports = __webpack_public_path__ + "img/platinumGold@2x.77d197c.jpg";